import type { TutorTaskPostponePayload } from '../../model/tutor-tasks/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorTaskPostponeApiOptions {
  taskId: number
  payload: TutorTaskPostponePayload
  onStart?: () => void
  onFinish?: () => void
}

/** `POST /admin-api/tutor-tasks/{task}/postpone` — moves the task to the next confirmed lesson. */
export const useTutorTaskPostponeApi = async (options: TutorTaskPostponeApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutor-task.postpone', { task_id: options.taskId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.post<ApiResponse>(url, options.payload)
    toast.success('The task was successfully postponed.')

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    options.onFinish?.()
  }
}
